module.exports = __webpack_public_path__ + "img/r5.17f64bbb.jpg";